import React,{ Fragment } from 'react'
import { Link } from 'react-static'
// import ScrollAnimation from 'react-animate-on-scroll'
import mac from './img/mac-screen.svg'


// import SearchBar from '../../../includes/Forms/SearchBar'

const LineContent = () => (
    <Fragment>
      {/*  LINE CONTENT SECTION  */}
			<section className="LineContent">
				<div>
				
	
				<article className="container">
					<div className="row center-xs">
						<div className="col-xs-6">

		
              <div className="box"> 
								<img className="img" src={mac} width="300" />
								<h3>Understanding what experience the user could take on going to the relevant desired areas of the website.</h3>
						</div>
						</div>
					</div>
				</article>
			


				<article className="container">
					<div className="row center-xs">
						<div className="col-xs-6">
              <div className="box">
								<h3>Design Process</h3>
								<p>Starts with crafting ideas that will help fuel the visual communication process.</p>
							</div>

						</div>
					</div>
				</article>
        
        <article className="container">
					<div className="row center-xs">
						<div className="col-xs-6">

              <div className="box">
					  		<h3>User Flow</h3>
									<p>This is where we begin the actual important communication mechanism towards guiding the user to desired locations and areas of interest.</p>
							</div>

						</div>
					</div>
				</article>
        
        <article className="container">
					<div className="row center-xs">
						 <div className="col-xs-6">

              <div className="box">
								<h3>Content Shaping </h3>
									<p>Starts with crafting ideas that will help fuel the visual communication process.</p>
							</div>

						</div>
					</div>
				</article>

			
				<div className="getstart">
					<Link to="/getting-started" className="getting-started">
						start your project today!
					</Link>					
				</div>
			
			{/*
				<div className="container getstart">
					<SearchBar/>
				</div>
				*/}

				</div>  
			</section>
			  
    </Fragment>
)
export default LineContent


// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/Process/components/LineContent.js